export default __webpack_public_path__ + "static/media/farms.7f7eb79f.png";